module.exports = __webpack_public_path__ + "static/img/mute_camera.ce9f976.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/mute_camera.png
// module id = DyLU
// module chunks = 24